// #region Dependencias
import { configureStore } from '@reduxjs/toolkit'
import rootReducer from 'store/rootReducer'
// #endregion

/**
 * Store de Redux de la aplicación, con su respectiva configuración.
 */
const store = configureStore({
  reducer: rootReducer,
  devTools: false,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // Ignorar advertencias de callback al modificar el UI
        ignoredActions: ['ui/setDialogoAbierto'],
        ignoredPaths: ['ui.callback']
      }
    })
})

export default store
